var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsteriskBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2081V8.76979H3.62222L6.96875 9.37135L7.20031 8.76979L4.41611 6.86018L1.85797 4.2552L4.27278 1.83785L6.87503 4.39318L8.78262 7.18582L9.38356 6.95403L8.78262 3.62602V0H12.2119V3.62602L11.6164 6.93746L12.2174 7.16925L14.125 4.37661L16.7272 1.82128L19.142 4.23863L16.5894 6.84364L13.7997 8.75321L14.0312 9.35481L17.3778 8.75321H21V12.1916H17.3778L14.0312 11.59L13.7997 12.1916L16.5894 14.1012L19.142 16.7062L16.7272 19.1235L14.125 16.5627L12.2119 13.7921L11.6109 14.0239L12.2119 17.374V21H8.7771V17.374L9.37804 14.0239L8.7771 13.7921L6.86952 16.5792L4.26726 19.1401L1.85245 16.7227L4.41061 14.1178L7.1948 12.2081L6.96325 11.6066L3.6167 12.2081H0Z",
    fill: "#23F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsteriskBlue);
export default __webpack_public_path__ + "static/media/Asterisk_Blue.17dab2de1f869349cab163096831c693.svg";
export { ForwardRef as ReactComponent };